import {
  useCreateTrackingEvent,
  TrackingEventInputTrackingEventMeta,
} from "@/services/orval/internalApiV1";

export function useRecommenderTracking() {
  const { mutate: createTrackingEvent } = useCreateTrackingEvent();
  // {
  //   event: 'click',
  //   subtype: 'course_recommendation_box',
  //   session_id: '1234567890',
  //   url: 'https://www.example.com/course/1234567890',
  //   meta: {
  //     id: '1234567890',
  //     type: 'Course'
  //   }
  // }
  const trackClick = (
    subKind: string,
    url: string,
    meta: TrackingEventInputTrackingEventMeta
  ) => {
    createTrackingEvent({
      data: {
        trackingEvent: {
          kind: "click",
          subKind,
          url,
          meta,
        },
      },
    });
  };

  // {
  //   event: 'view',
  //   subKind: 'course_recommendation_box',
  //   session_id: '1234567890',
  //   url: 'https://www.example.com/homepage',
  //   meta: {
  //     reco_version: '1.0',
  //     recommendations: [
  //       {type: 'Course', id:'123', reco_type: 'interaction_based'},
  //       {type: 'Course', id:'234', reco_type: 'semantic_based'},
  //       {type: 'Course', id:'123', reco_type: 'interaction_based'},
  //       {type: 'Course', id:'234', reco_type: 'semantic_based'}
  //     ]
  //   }
  // }
  const trackView = (
    subKind: string,
    url: string,
    meta: TrackingEventInputTrackingEventMeta
  ) => {
    createTrackingEvent({
      data: {
        trackingEvent: {
          kind: "view",
          subKind,
          url,
          meta,
        },
      },
    });
  };

  let observer: IntersectionObserver;

  const startObserving = (
    element: HTMLElement,
    subKind: string,
    url: string,
    meta: TrackingEventInputTrackingEventMeta
  ) => {
    observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackView(subKind, url, meta);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(element);
  };

  const stopObserving = () => {
    !!observer && observer.disconnect();
  };

  return {
    trackView,
    trackClick,
    startObserving,
    stopObserving,
  };
}
